module.exports = __webpack_public_path__ + "static/media/Logo.a7bcd217.png";